import { JiraServiceClient } from "../../provider/clients/jira-service.client";
import { executeWithRefresh, getLoggedUser } from "../../provider/authProvider";
import { detectPlatform, isApplePlatform } from "../../utils/platfrom.helper";

const jiraServiceClient = new JiraServiceClient();

export const mapsSelector = (address: string) => {
  const platform = detectPlatform();
  if (isApplePlatform(platform))
    /* else Apple maps */
    window.open(`maps://maps.google.com/maps?daddr=${address}&amp;ll=`);
  /* else use Google mpas */ else
    window.open(`https://maps.google.com/maps?daddr=${address}&amp;ll=`);
};

export const getCoordinatesForLocation = async (address: string) => {
  const authUser = getLoggedUser();
  const coordinates = await executeWithRefresh<{
    lat: number;
    lng: number;
  } | null>({
    authUser,
    func: jiraServiceClient.getCoordinates,
    args: [address],
    silentFail: true,
  });
  return coordinates ?? undefined;
};
